import clsx from 'clsx';
import Image from 'components/ui/Image';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './ImageRow.module.scss';
import RichText from './RichText';
import type { IBlockImageRowFields } from 'types/contentful/generated';
import type { Image as ImageType } from 'types/Utilities';
import type { RichTextConfig } from 'components/ui/ContentBlocks/RichText';
import type { Document } from '@contentful/rich-text-types';

const { sharedStyle } = styles;
const richTextConfig: RichTextConfig = {
  'heading-3': clsx(sharedStyle, 'text-2xl'),
  'heading-4': clsx(sharedStyle, 'text-xl'),
  'heading-5': clsx(sharedStyle, 'text-lg'),
  'heading-6': clsx(sharedStyle, 'text-md'),
};

const alignClass = {
  Left: styles.alignLeft,
  Center: styles.alignCenter,
  Right: styles.alignRight,
};

type Props = IBlockImageRowFields & {
  descriptionContent?: Document;
  imageItems?: ImageType[];
};

const ImageRow = ({
  blockId,
  description,
  descriptionContent,
  items,
  imageItems,
}: Props): JSX.Element => {
  // eslint-disable-next-line
  // @ts-ignore
  const images = imageItems ? imageItems.items : items;

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
      {(descriptionContent || description) && (
        <div className={styles.description}>
          <RichText fields={descriptionContent || description} />
        </div>
      )}
      {images && (
        <div className={styles.images}>
          {
            // eslint-disable-next-line
            // @ts-ignore
            images.map((item, i) => {
              const itemFields = item.fields || item;
              const { image, description, descriptionContent } = itemFields;
              const { description: imageDescription, title: imageTitle } =
                image;

              return (
                <div key={i} className={styles.item}>
                  {(description || descriptionContent) && (
                    <div className="pr-5">
                      <div
                        className={clsx(
                          styles.imageWrapper,
                          alignClass[
                            itemFields.imageAlignment as keyof typeof alignClass
                          ],
                        )}
                      >
                        <Image
                          className={styles.image}
                          src={image.fields?.file.url || image.url}
                          alt={imageDescription || imageTitle || ''}
                          width={160}
                          height={160}
                          contentful
                        />
                      </div>

                      {(description || descriptionContent) && (
                        <div className={styles.itemDescription}>
                          <RichText
                            fields={description || descriptionContent}
                            config={richTextConfig}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          }
        </div>
      )}
    </div>
  );
};

export default ImageRow;
